import { H5, ParagraphBody } from '@by-miles/bymiles-styles'
import { ReactNode } from 'react'

import { StepBullet } from '../StepBullet'
import { ExplainerStepStyles } from './ExplainerStepStyles'

interface ExplainerStepProps {
  step: number
  title: string
  text: string
  button: ReactNode
  activeStep: number
  progress: number
}

export const ExplainerStep = ({ step, title, text, button, activeStep, progress }: ExplainerStepProps) => {
  const isCurrent = step === activeStep
  return (
    <ExplainerStepStyles isCurrent={isCurrent}>
      <div className="step-wrapper">
        <StepBullet percentage={isCurrent ? progress : 0} bullet={step} active={isCurrent} />
        <div className="content">
          <H5>{title}</H5>
          {isCurrent && (
            <>
              <ParagraphBody className="text">{text}</ParagraphBody>
              <div className="button-tablet">{button}</div>
            </>
          )}
        </div>
      </div>
      <div className="button-mobile">{button}</div>
    </ExplainerStepStyles>
  )
}
